import React from 'react';
import PropTypes from 'prop-types';
import { Container, PauseButton } from './Styles';

const PauseContinueLane = ({
  show,
  onClick,
  bgColor,
  bgVariance,
  color,
  icon,
  isLanePaused,
  iconOnly,
}) => {
  const getButtonText = () => {
    if (iconOnly) return null;
    return !isLanePaused ? 'PAUSE LANE' : 'CONTINUE LANE';
  };

  return (
    <>
      {show && (
        <Container>
          <PauseButton
            onClick={onClick}
            bgColor={bgColor}
            color={color}
            bgVariance={bgVariance}
          >
            <i className={`fa ${icon}  fa-2`} aria-hidden="true" />
            {getButtonText()}
          </PauseButton>
        </Container>
      )}
    </>
  );
};

PauseContinueLane.defaultProps = {
  show: false,
  icon: 'fa-pause-circle',
  iconOnly: false,
};

PauseContinueLane.propTypes = {
  show: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  bgColor: PropTypes.string.isRequired,
  bgVariance: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  icon: PropTypes.string,
  isLanePaused: PropTypes.bool.isRequired,
  iconOnly: PropTypes.bool,
};

export default PauseContinueLane;
